// slidePreview.js
import React from "react";
import Logo from "./Logo";


export default function SlidePreview({ index, isActive }) {
  return (
    <div
     key={isActive}
      style={{
        ...styles.container,
       ...(isActive ? styles.active : {}),
      }}
    >
      <div style={styles.preview}>
        <Logo size={12} />
      </div>
      <span style={styles.index}>{index}</span>
    </div>
  );
}

const styles = {
  container: {
    borderRadius: 6,
    padding: 4,
    border: "2px solid transparent",
    background: "#fff",
    transition: "all 0.15s ease",
    outline: "none",
    borderColor: 'transparent !important',
    boxShadow: 'none !important',
  },
  active: {
    borderColor: "green", // <--- Change this to your desired color (e.g., "green", "#f00")
    boxShadow: "0 0 0 2px rgba(59,0,255,0.1)",
  },
  preview: {
    aspectRatio: "9 / 16",
    border: "1px solid #ddd",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fafafa",
  },
  index: {
    display: "block",
    marginTop: 4,
    fontSize: 11,
    textAlign: "center",
    color: "#666",
  },
};
